<template>
  <div id="googlemapsholder" class="disable-all googlemapsapp">
    <div id="POIcanvas-map" @click="toggleInfoVisible(false)"></div>
    <div class="POIinterface" v-if="poiInterface.filtersVisible">
      <div>
        <filtercollection :title="$store.state.translation[90]" @showfiltercol="filterBtnClick">
          <Xfilter :filtertitle="$store.state.translation[14161]">
            <input
              type="search"
              @keyup.enter="filterBtnClick"
              v-model="valuesearchpraktijk"
              class="form-control"
              id="email"
            />
          </Xfilter>
          <Xfilter
            :filtertitle="filter.searchFieldScreenName"
            v-for="(filter, index) in filters"
            :key="'filter' + index"
          >
            <div
              v-if="
                filter.searchFieldFieldType == 4 ||
                filter.searchFieldFieldType == 8 ||
                filter.searchFieldFieldType == 12
              "
            >
              <input
                class="form-control"
                :id="'inputSearch' + filter.searchFieldID"
                @keyup.enter="filterBtnClick"
                v-model="filter.searchFieldvalue"
              />
            </div>
            <div v-if="filter.searchFieldFieldType === 5">
              <Xdropdownfilter
                name="specfilter"
                @input="filterBtnClick"
                v-model="filter.searchFieldvalue"
                v-bind:options="filterOptions(allspecs, filter.searchFieldID)"
              ></Xdropdownfilter>
            </div>
            <!-- <div
              v-if="
                filter.searchFieldFieldType === 3 &&
                  (filter.searchFieldSearchType === 5 ||
                    filter.searchFieldSearchType === 6 ||
                    filter.searchFieldSearchType === 7 ||
                    filter.searchFieldSearchType === 8)
              "
              class="sliderpadding"
            >
              <vue-slider
                :name="'slider' + index"
                @change="filterBtnClick"
                v-model="filter.searchFieldvalue"
                :min="filter.searchFieldMinValue"
                :max="filter.SearchFieldMaxValue"
                :interval="filter.SearchFieldStepsValue"
                :adsorb="true"
                :marks="true"
                :duration="0.2"
                :lazy="true"
              ></vue-slider>
            </div>-->
          </Xfilter>
        </filtercollection>
      </div>
    </div>
    <div>
      <div class="POIsearchdiv">
        <div class="form-group" v-if="!wLG && !wXL && !poiInterface.filtersVisible">
          <span class="btn-block btn btn-primary hidden-md" v-on:click="togglefiltersVisible(true)">{{
            $store.state.translation[14123]
          }}</span>
        </div>
      </div>
    </div>
    <NextgooglemapsInterface
      v-if="poiInterface.infoVisible"
      id="mapsinterface"
      v-bind:markerdata="poiInfo"
    ></NextgooglemapsInterface>
  </div>
</template>

<script>
// import fam from 'fontawesome-markers'
import { util } from 'pevueglobal'
import NextgooglemapsInterface from './NextgooglemapsInterface.vue'
import MarkerClusterer from '@google/markerclustererplus'
import { mapActions, mapGetters, mapMutations } from 'vuex'

var gmapGlobal
var globalmarkercluster
export default {
  components: { NextgooglemapsInterface },
  data() {
    return {
      fontawesomemarkers: {},
      markerindex: 0,
      googlemapsOptions: {
        // map settings
        zoom: 8,
        center: new google.maps.LatLng(51.96593143, 5.0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'greedy',
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      },
      card: '',
      markers: [],
      clickedmarkerdata: [],
      valuesearchpraktijk: '',
      // mapfilters: { mapfilters staat verder nergens?
      //   praktijknaam: '',
      //   specialisme: ''
      // },
      settrans: true,
    }
  },
  props: ['markerdata'],
  computed: {
    ...mapGetters('PointsOfInterest', [
      'poiInfo',
      'poiInterface',
      'filters',
      'clientFilters',
      'serverFilters',
      'serverFilterValues',
      'tblProfGroupGoogleApiKey',
      'allspecs',
    ]),
  },
  mounted() {
    if (!this.$route.query.legacy) {
      window.location = '/fe/public/pointsOfInterest/' + this.$route.params.profgroupID
    }
    this.SetupGooglemaps()
  },
  watch: {
    wLG: function (val) {
      this.togglefiltersVisible(this.wLG || this.wXL)
    },
  },
  methods: {
    ...mapActions('PointsOfInterest', ['PEapi_PointsOfInterest_Info', 'PEapi_PointsOfInterest_Search']),
    ...mapMutations('PointsOfInterest', ['togglefiltersVisible', 'toggleInfoVisible']),
    filterOptions: function (options, filterType) {
      return options.filter(function (option) {
        return option.searchFieldID === filterType
      })
    },
    SetupGooglemaps() {
      this.togglefiltersVisible(this.wLG || this.wXL)
      gmapGlobal = new google.maps.Map(document.getElementById('POIcanvas-map'), this.googlemapsOptions)

      globalmarkercluster = new MarkerClusterer(gmapGlobal, [], {
        zoomOnClick: true,
        minimumClusterSize: 2,
        averageCenter: true,
        styles: [
          {
            url: '/images/googlemaps/markerbluecircle.png',
            height: 30,
            width: 30,
            textColor: '#ffffff',
            textSize: 10,
          },
        ],
      })

      // Dont spiderfy clusters < 17 zoom level
      const minSpiderfyZoomLevel = 17
      let markersToReset = []

      gmapGlobal.addListener('zoom_changed', function () {
        if (gmapGlobal.getZoom() < minSpiderfyZoomLevel) {
          for (let i = 0; i < markersToReset.length; i++) {
            const marker = markersToReset[i]

            // Nieuwe (eigenlijk oude) positie voor marker
            const newPos = new google.maps.LatLng(marker.lat, marker.lng)

            // Reset de marker en lijn
            marker.marker.setPosition(newPos)
            marker.line.setPath([])
          }
          markersToReset = []
        }
      })

      google.maps.event.addListener(globalmarkercluster, 'click', (cluster) => {
        // Check of het cluster opgesplitst moet worden in markers ...
        if (gmapGlobal.getZoom() >= minSpiderfyZoomLevel) {
          // Het cluster opspliten

          // Map nieuwe coordinaten naar het zoom level
          const offset = -0.0004

          for (let i = 0; i < cluster.markers_.length; i++) {
            const marker = cluster.markers_[i]

            const pos = cluster.center_
            const a = 360.0 / cluster.markers_.length
            const newLat = pos.lat() + offset * Math.cos(((+a * i) / 180) * Math.PI)
            const newLng = pos.lng() + offset * Math.sin(((+a * i) / 180) * Math.PI)
            const newPos = new google.maps.LatLng(newLat, newLng)

            const myPath = [
              { lat: pos.lat(), lng: pos.lng() },
              { lat: newLat, lng: newLng },
            ]
            const line = new google.maps.Polyline({
              path: myPath,
              strokeColor: '#FF0000',
              strokeOpacity: 1.0,
              strokeWeight: 2,
              map: gmapGlobal,
            })

            // Push alle informatie naar array zodat het later gereset kan worden
            const markerToReset = {
              marker: marker,
              lat: marker.getPosition().lat(),
              lng: marker.getPosition().lng(),
              line: line,
            }
            markersToReset.push(markerToReset)

            marker.setVisible(true)
            // Verplaats marker naar nieuwe pos
            marker.setPosition(newPos)
          }
        }
        // Not showing info on cluster click anymore, just zoom in on it
      })

      for (let markerInfo of this.markerdata) {
        var mysmarkerinfo = {
          position: new google.maps.LatLng(
            markerInfo.tblPointOfInterestCoordinateRetrievedLat,
            markerInfo.tblPointOfInterestCoordinateRetrievedLong
          ),
          map: gmapGlobal,
        }

        mysmarkerinfo.markerInfo = markerInfo
        var marker = new google.maps.Marker(mysmarkerinfo, true)

        let markerEventClick = (m) => {
          // huilen met google maps, elke vorm van bubble prevent werkt niet, dus timeout
          // m.stop()
          // console.log(m)
          // m.wa.cancelBubble = true
          // m.wa.stopPropagation()
          // m.wa.returnValue = false
          // console.log('marker')
          // console.log(m)

          setTimeout(() => {
            this.PEapi_PointsOfInterest_Info({
              poiIDs: [markerInfo.tblPointOfInterestID],
              profgroupID: this.$route.params.profgroupID,
            })
            this.toggleInfoVisible(true)
          }, 100)
          return false
        }

        marker.setVisible(true)
        globalmarkercluster.addMarker(marker)

        marker.addListener('click', markerEventClick)

        marker.addListener('visible_changed', function () {
          if (this.getVisible()) {
            globalmarkercluster.addMarker(this)
          } else {
            globalmarkercluster.removeMarker(this)
          }
        })

        // Add the marker
        this.markers.push(marker)
      }
    },
    showfilters: function () {
      if (this.poiInterface.filtersVisible === false) {
        return 'hidden-xs hidden-sm hidden-md col-lg-3'
      } else {
        return 'col-md-3'
      }
    },
    async inputsearchpraktijk() {
      var response = await util.coreApiGet(
        '/api/v1/public/GoogleMapsApi/GetGoogleMapsResult/',
        this.valuesearchpraktijk
      )
      var location = response.results[0].geometry.location
      gmapGlobal.setZoom(12)
      gmapGlobal.setCenter(location)
    },
    async filterBtnClick() {
      setTimeout(async () => {
        this.toggleInfoVisible(false)

        if (globalmarkercluster) {
          globalmarkercluster.clearMarkers()
        }
        if (!this.wLG && !this.wXL) {
          this.togglefiltersVisible(false)
        }
        let needServerSearch = false
        for (let serverFilter of this.serverFilters) {
          if (needServerSearch === false) {
            needServerSearch = serverFilter.searchFieldvalue !== undefined && serverFilter.searchFieldvalue !== ''
          }
        }

        var bounds = new google.maps.LatLngBounds()
        if (needServerSearch === false) {
          if (this.valuesearchpraktijk !== '') {
            this.inputsearchpraktijk()
          }

          for (let clientfilter of this.clientFilters) {
            if (
              clientfilter.searchFieldSearchType === 0 &&
              clientfilter.searchFieldFilterName === 'TblPointOfInterestName'
            ) {
              // bevat filter voor naam Point of interest
              this.markers.filter((o) => {
                if (clientfilter.searchFieldvalue === undefined) {
                  o.setVisible(true)
                  return
                }

                if (
                  clientfilter.searchFieldvalue !== undefined &&
                  o.markerInfo.tblPointOfInterestName
                    .toUpperCase()
                    .indexOf(clientfilter.searchFieldvalue.toUpperCase()) !== -1
                ) {
                  o.setVisible(true)
                  bounds.extend(o.getPosition())
                  return
                }
                o.setVisible(false)
              })
            }
          }
        } else {
          // composer filter settings for SP
          let spFilters = []
          let resetfilter = true
          this.filters.forEach((f) => {
            if (f.searchFieldSearchType === 7) {
              if (f.searchFieldvalue !== f.searchFieldMinValue) {
                resetfilter = false
              }
            } else {
              if (f.searchFieldvalue !== '') {
                resetfilter = false
              }
            }
          })

          if (resetfilter === false) {
            this.filters.forEach((f) => {
              if (f.searchFieldvalue !== undefined && f.searchFieldvalue !== '' && f.searchFieldSearchType !== 7) {
                // veld filter
                spFilters.push({
                  key: f.searchFieldFilterName,
                  value: f.searchFieldvalue,
                  datevalue: null,
                  intvalue: null,
                  decimalvalue: null,
                  searchType: f.searchFieldSearchType,
                })
              }
              if (
                f.searchFieldvalue !== undefined &&
                f.searchFieldvalue !== '' &&
                f.searchFieldSearchType === 7 &&
                f.searchFieldvalue > f.searchFieldMinValue
              ) {
                // slider filter

                spFilters.push({
                  key: f.searchFieldFilterName,
                  value: null,
                  datevalue: null,
                  intvalue: null,
                  decimalvalue: f.searchFieldvalue,
                  searchType: f.searchFieldSearchType,
                })
              }
            })
            await this.PEapi_PointsOfInterest_Search({
              filters: spFilters,
              profgroupID: this.$route.params.profgroupID,
            })
            this.markers.filter((o) => {
              if (
                this.serverFilterValues.filter((sf) => sf.tblPointOfInterestID === o.markerInfo.tblPointOfInterestID)
                  .length !== 0
              ) {
                o.setVisible(true)
                bounds.extend(o.getPosition())
                return
              }
              o.setVisible(false)
            })
          } else {
            // Reset de server filter die gezet word door PEapi_PointsOfInterest_Search
            await this.resetFilters()

            // dit zet alle markers op visible in googlemaps
            this.markers.filter((o) => {
              o.setVisible(true)
              bounds.extend(o.getPosition())
            })
          }
        }
        globalmarkercluster.repaint()
        if (!bounds.isEmpty()) {
          // center the map to the geometric center of all markers
          if (this.valuesearchpraktijk === '') {
            gmapGlobal.setCenter(bounds.getCenter())
            gmapGlobal.fitBounds(bounds)
          } else {
            this.inputsearchpraktijk()
          }
          // set a minimum zoom
          // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
          if (gmapGlobal.getZoom() > 15) {
            gmapGlobal.setCenter(bounds.getCenter())
            gmapGlobal.setZoom(15)
          }
        } else {
          if (this.valuesearchpraktijk === '') {
            gmapGlobal.setCenter(new google.maps.LatLng(51.96593143, 5.0))
            gmapGlobal.setZoom(8)
          }
        }
      }, 200)
    },
  },
}
</script>
<style></style>
